<template>
  <div class="paddingLine"></div>
  <dc-layout-card title="评论记录" :isAutoLayout="false">
    <span v-if="props.score > 0">
      <a-rate style="margin-bottom: 16px;" v-model:value="score" :disabled="true" :tooltips="commentDesc"  />
      <span class="ant-rate-text">{{ commentDesc[props.score - 1] }}</span>
    </span>
    <div class="commit-list" v-for="item in pageData" :key="item.id">
      <div class="flex">
        <p>{{ item.createByName }}</p>
        <p>{{ item.createTime }}</p>
      </div>
      <div v-html="xss(item.content)"></div>
      <template v-if="item.fileId && item.fileId.length">
        <p style="margin-bottom: -6px">附件：</p>
        <UploadFile v-model:value="item.fileId" view valueType="array" />
      </template>
      <div class="button">
        <a-button type="text" v-permission="permissionPage.delCommit" @click="handleDelCol(item)" danger>删除</a-button>
      </div>
    </div>
  </dc-layout-card>
</template>
<script lang="ts" setup>
import { ref, computed } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import UploadFile from '@/components/UploadFile'
import Modal from '@/hooks/modalType'
import type { LbuSaleCoachingCommentItem } from '@/typings/api/saleCoaching'
import { saleCoachingDetail, saleCoachingCommentDelete } from '@/api/yuntuSales/saleCoaching'
import xss from 'xss'
import { number } from 'vue-types'
const props = defineProps({
  data: {
    type: Array,
    default: () => {
      return []
    }
  },
  score: {
    type: number,
    default: () => {
      return 0
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  id: String
})
const hasfetch = ref(false)
const commentList = ref([])
const pageData = computed(() => {
  if (hasfetch.value) {
    return commentList.value
  }
  return props.data || []
})

const score = computed(() => {
  return props.score
})

const refresh = () => {
  saleCoachingDetail({ id: props.id }).then((res) => {
    hasfetch.value = true
    commentList.value = res.data.commentList
  })
}
const commentDesc = ref<string[]>(['非常不满意', '不满意', '一般', '满意', '非常满意'])

const handleDelCol = (row: LbuSaleCoachingCommentItem) => {
  Modal.delete({
    onOk() {
      saleCoachingCommentDelete({ id: row.id }).then((res) => {
        DcMessage.success('删除成功')
        refresh()
      })
    }
  })
}
defineExpose({
  refresh
})
</script>
<script lang="ts">
export default {
  name: 'commitList'
}
</script>
  <style scoped lang="scss">
.commit-list {
  padding: 10px;
  margin-bottom: 15px;
  background: #f9f9ff;
  width: 100%;
  position: relative;
  p {
    margin-right: 20px;
    margin-bottom: 10px;
  }
  .button {
    position: absolute;
    right: 20px;
    top: 10px;
  }
}
.paddingLine {
  height: 12px;
  margin-left: -20px;
  margin-right: -20px;
  bottom: 0;
  background: #f9f9ff;
  margin-bottom: 16px;
}
</style>
